import { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Table,
  Card,
} from 'antd';
import { string } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useRequest } from 'ahooks';
import { useSelector } from 'react-redux';
import SearchForm from '@/components/SearchForm';
import {
  getOrderList,
} from '@/services/supplyChainFinance';

export default function TabChildren(props) {
  const { tabKey } = props;
  const [form] = Form.useForm();
  const Navigate = useNavigate();
  const [searchParams, setSearchParams] = useState({});
  const { userInfo } = useSelector((state) => state);
  // 列表
  const { data: list, loading, run } = useRequest((val = {}) => getOrderList({ ...val, status: Number(tabKey) }), {
    manual: true,
  });

  // 监听 tabKey 变化，自动刷新列表
  useEffect(() => {
    run({ ...searchParams });
  }, [tabKey, run]);

  function submit(val = {}) {
    setSearchParams(val);
    run(val);
  }
  function handleDetail(id) {
    Navigate(`/supplyChain/detail?id=${id}&applicantId=${userInfo.id}`);
  }
  const handleEdit = (id) => {
    Navigate(`/supplyChain/detail?id=${id}&applicantId=${userInfo.id}&edit=true`);
  };
  const columns = [
    {
      title: '企业名称/姓名',
      dataIndex: 'applicantName',
      width: 150,
    },
    {
      title: '统一社会信用代码/身份证号码',
      dataIndex: 'applicantNo',
      width: 200,
    },
    {
      title: '项目名称',
      dataIndex: 'projectName',
      width: 150,
    },
    {
      title: '所属产业链',
      dataIndex: 'industryChainBelongs',
      width: 150,
    },
    {
      title: '联系人',
      dataIndex: 'contactName',
      width: 100,
    },
    {
      title: '手机号',
      dataIndex: 'contactPhone',
      width: 120,
    },
    {
      title: '主体角色',
      dataIndex: 'mainRoleValue',
      width: 120,
    },
    {
      title: '操作',
      dataIndex: 'option',
      width: 140,
      fixed: 'right',
      render: (_, record) => (
        <>
          <a
            style={{ marginRight: 10 }}
            onClick={() => handleDetail(record.id)}
          >
            详情
          </a>
          <a
            hidden={tabKey !== '0'}
            onClick={() => handleEdit(record.id)}
          >
            关系确认
          </a>
        </>
      ),
    },
  ];

  const onChange = (pageNum, pageSize) => {
    run({ pageNum, pageSize, ...searchParams });
  };

  return (
    <div>
      <style>
        {`
          .supply-chain-search-form .search-form .form-item {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        `}
      </style>
      <div className="supply-chain-search-form">
        <SearchForm
          form={form}
          onSubmit={submit}
        >
          <Form.Item name="applicantName" label="企业名称/姓名">
            <Input placeholder="请输入企业名称/姓名" />
          </Form.Item>
          <Form.Item name="applicantNo" label="统一社会信用代码/身份证号码">
            <Input placeholder="请输入统一社会信用代码/身份证号码" />
          </Form.Item>
        </SearchForm>
      </div>
      <Card>
        <Table
          loading={loading}
          columns={columns}
          dataSource={list?.items}
          rowKey="id"
          scroll={{ x: 1500 }}
          pagination={{
            onChange,
            total: list?.totalRows,
            showSizeChanger: true,
            showTotal: (total) => `总计： ${total}条`,
          }}
        />
      </Card>
    </div>
  );
}
TabChildren.propTypes = {
  tabKey: string,
};
